import React from 'react';
import FeaturedImageUpload from '../../../Editor/FeaturedImageUpload';
import FormWithDescription from '../../FormWithDescription';

export default function LogoPicker({
  logo,
  setLogo,
  setLogoDimensions,
  title,
  label,
  placeholder,
}) {
  return (
    <FormWithDescription title={title} description={label} marginTop>
      <FeaturedImageUpload
        setFeaturedDimensions={setLogoDimensions}
        featuredImage={logo}
        setFeaturedImage={setLogo}
        placeholder={placeholder}
      />
    </FormWithDescription>
  );
}
